import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Navigator from './Navigator';
import Question from './questionnaire/Question';

class Questionnaire extends React.Component {
  initialAnswers = [];

  constructor(props) {
    super(props);

    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    let questions = props.questions.map((question, idx) => ({ qID: idx, ...question, answered: false }));
    this.initialAnswers = props.answers;

    return {
      questions: questions,
      answers: props.answers,
      completed: this.isComplete(questions) || props.answers.length > 0
    };
  }

  render() {
    const { hideNavigator, submitting, onButtonPrevious, className } = this.props;
    const { answers, completed } = this.state;

    return (
      <React.Fragment>
        <div className={cx('questionnaire', className)}>
          { this.state.questions.map((question) =>
            <Question
              key={question.qID}
              mainQuestion={true}
              answers={answers}
              question={question}
              submitting={submitting}
              onAnswer={this.onAnswer.bind(this, question.qID)}
            />
          )}
        </div>

        { !hideNavigator &&
          <Navigator
            enableNext={completed}
            enablePrevious={true}
            submitting={submitting}
            onButtonNext={this.submit.bind(this)}
            onButtonPrevious={onButtonPrevious}
          />
        }
      </React.Fragment>
    );
  }

  onAnswer(qID, id, choice_id, overrideID, answered) {
    let questions = this.state.questions;
    let question = questions.find(q => q.qID === qID);
    let answers = [...this.state.answers];
    let answer = answers.find(a => a.id === id || a.id === overrideID);

    if (answer) {
      answer.id = id;
      answer.choice_id = choice_id;
    } else {
      answer = { id: overrideID || id, choice_id };
      answers.push(answer);
    }

    question.answered = answered;

    this.setState({
      answers: answers.filter(a => a.choice_id),
      questions: questions
    }, this.checkCompletion);
  }

  checkCompletion() {
    if (this.isComplete(this.state.questions)) {
      this.setState({ completed: true }, () => {
        if (this.props.autoSubmit && !this.answersEqualInitialAnswers()) { this.submit(); }
      });
    } else {
      this.setState({ completed: false });
    }
  }

  isComplete(questions) {
    return !questions.some(q => !q.answered);
  }

  answersEqualInitialAnswers() {
    return this.state.answers.every(a => this.initialAnswers.includes(a));
  }

  submit() {
    this.props.onButtonNext(this.state.answers);
  }
}

Questionnaire.defaultProps = {
  className: '',
  answers: [],
  autoSubmit: false,
  submitting: false,
  hideNavigator: false
};

Questionnaire.propTypes = {
  className: PropTypes.string,
  answers: PropTypes.array,
  questions: PropTypes.array.isRequired,
  submitting: PropTypes.bool,
  onButtonNext: PropTypes.func.isRequired,
  onButtonPrevious: PropTypes.func,
  autoSubmit: PropTypes.bool,
  percentage: PropTypes.number,
  hideNavigator: PropTypes.bool
};

export default Questionnaire;
